// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + chunkId + "." + "f09802e8c07da0bd6051" + ".js";
};